import { render, staticRenderFns } from "./RelatorioCotasUnidadeListFiltro.vue?vue&type=template&id=233e6f14"
import script from "./RelatorioCotasUnidadeListFiltro.vue?vue&type=script&lang=js"
export * from "./RelatorioCotasUnidadeListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports